export class SaasEmailSearchFilter {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_from",
            "baseName": "from",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "to",
            "baseName": "to",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "subject",
            "baseName": "subject",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasEmailSearchFilter.attributeTypeMap;
    }
    constructor() {
    }
}
